import React from "react";
import { IAudioState } from "providers/AudioProvider/types";
import { IAudioHandles } from "providers/AudioProvider/handleTypes";
import { SettingsButtonSC } from "./styled";
import { SettingsMIcon } from "../../../../elements/icons/SettingsMIcon";
import { useLocation } from "react-router-dom";
import { SettingsPanel } from "./SettingsPanel";
import { ClipReadout } from "../ClipReadout";

interface IFooterProps {
    handles: IAudioHandles;
    state: IAudioState;
    view?: string[];
}

/**
 * The gear in the corner of the editor, and the panel it opens.
 *
 * The panel used to be a strip along the bottom of the screen that pushed the waveforms up
 * whenever it was open; it is now a drawer (see SettingsPanel), which is why nothing here lays
 * anything out any more.
 */
export function AudioFooter({
    handles,
    state,
    view = ["audioVolume", "zoomLevel", "voicingSpacesMinimum", "speed"],
}: IFooterProps) {
    const location = useLocation();
    const [visible, setVisible] = React.useState(false);
    const isDebugMode = new URLSearchParams(location.search).has("debug");

    return (
        <>
            <SettingsButtonSC title="Настройки" onClick={() => setVisible(true)}>
                <SettingsMIcon fontSize={"1.6em"} />
            </SettingsButtonSC>
            {/* Сколько озвучек уже готово звучать — единственная цифра, по которой видно,
                что «тормозит» именно подготовка, и именно на этой машине. */}
            <ClipReadout />
            <SettingsPanel
                open={visible}
                onClose={() => setVisible(false)}
                handles={handles}
                state={state}
                view={view}
                isDebugMode={isDebugMode}
            />
        </>
    );
}
